import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { midPoint } from '../redux/scales';
import s from './LoveSlider.scss';
function generateParticleVectors() {
    // a biased semi-random set of movement vectors for the particles
    var particleVectors = [
        [-0.9, 0.05],
        [-0.95, -0.93],
        [-0.92, 0.91],
        [0.03, -0.97],
        [0.09, 0.93],
        [0.9, 0.98],
        [0.92, 0.06],
        [0.98, -0.91],
    ].map(function (_a) {
        var x = _a[0], y = _a[1];
        return ({
            vector: [x * Math.random(), y * Math.random()],
            sortBy: Math.random(),
        });
    });
    particleVectors.sort(function (a, b) { return a.sortBy - b.sortBy; });
    return particleVectors.map(function (_a) {
        var vector = _a.vector;
        return vector;
    });
}
var Particles = /** @class */ (function (_super) {
    tslib_1.__extends(Particles, _super);
    function Particles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // each instance gets its own special set of shiny
        _this.particleVectors = generateParticleVectors();
        return _this;
    }
    Particles.prototype.render = function () {
        var _a = this.props, lovePercentage = _a.lovePercentage, className = _a.className;
        // our base scaling contant, bigger number more precise numbers but tinier particles
        var particleRadius = 25;
        // base percentage of our spot within the love half of the scale
        var baseLovePercentage = (midPoint - lovePercentage) / midPoint;
        // for calculating offsets, we want to keep the particles more around the outer perimeter
        var scaleFactor = (2 + baseLovePercentage) / 3;
        if (scaleFactor < 0) {
            return null;
        }
        var offsets = this.particleVectors
            .map(function (_a) {
            var x = _a[0], y = _a[1];
            return [
                (1 + x * scaleFactor) * particleRadius,
                (1 + y * scaleFactor) * particleRadius,
            ];
        })
            .map(function (_a) {
            var x = _a[0], y = _a[1];
            return "translate(" + x + " " + y + ")";
        });
        return (React.createElement("svg", { viewBox: "0 0 " + particleRadius * 2 + " " + particleRadius * 2, className: className, xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("defs", null,
                React.createElement("linearGradient", { x1: "85.355%", y1: "14.645%", x2: "14.645%", y2: "85.355%", id: "particle-gradient-a" },
                    React.createElement("stop", { stopColor: "#00F4CB", offset: "0%" }),
                    React.createElement("stop", { stopColor: "#00E59B", offset: "100%" })),
                React.createElement("linearGradient", { x1: "100%", y1: "50%", x2: "0%", y2: "50%", id: "particle-gradient-b" },
                    React.createElement("stop", { stopColor: "#00F4CB", offset: "0%" }),
                    React.createElement("stop", { stopColor: "#00E59B", offset: "100%" }))),
            React.createElement("g", { fill: "none", fillRule: "evenodd", opacity: baseLovePercentage },
                React.createElement("path", { fill: "#00E59B", d: "M24.99 25l-.288.5.298.49-.5-.288-.5.287.287-.5-.276-.489.478.287z", transform: offsets[0], className: classnames(s['particle'], s['particle-0']) }),
                React.createElement("path", { fill: "url(#particle-gradient-a)", opacity: ".369", d: "M.5 0l.5.5-.5.5L0 .5z", transform: offsets[1], className: classnames(s['particle'], s['particle-1']) }),
                React.createElement("path", { fill: "url(#particle-gradient-a)", d: "M.5 0l.5.5-.5.5L0 .5z", transform: offsets[2], className: classnames(s['particle'], s['particle-2']) }),
                React.createElement("path", { fill: "url(#particle-gradient-a)", d: "M.5 0l.5.5-.5.5L0 .5z", transform: offsets[3], className: classnames(s['particle'], s['particle-3']) }),
                React.createElement("path", { fill: "url(#particle-gradient-a)", d: "M.976 0l.977.5-.977.5L0 .5z", transform: offsets[4], className: classnames(s['particle'], s['particle-4']) }),
                React.createElement("path", { fill: "#00E59B", d: "M24.495 25l-.108.398-.387.097.387.107.108.398.107-.398.398-.107-.398-.097z", transform: offsets[5], className: classnames(s['particle'], s['particle-5']) }),
                React.createElement("path", { fill: "url(#particle-gradient-b)", opacity: ".369", d: "M1 0v1H0V0z", transform: offsets[6], className: classnames(s['particle'], s['particle-6']) }),
                React.createElement("path", { fill: "url(#particle-gradient-a)", d: "M.5 0l.5.5-.5.5L0 .5z", transform: offsets[7], className: classnames(s['particle'], s['particle-7']) }))));
    };
    return Particles;
}(React.Component));
export { Particles };
export default Particles;
//# sourceMappingURL=Particles.js.map